import { usePostHog } from 'posthog-js/react';
import { useEffect, useState } from 'react';
import { OneTrustConsentGroups } from '~/enums';

const useConsent = () => {
  const postHog = usePostHog();

  const [consentData, setConsentData] = useState<OneTrustConsentGroups[]>([]);

  const readDataAndSetConsentPref = (
    data: CustomEvent<OneTrustConsentGroups[]>
  ) => {
    if (window.OneTrust) {
      setConsentData(data.detail);
    }
  };

  useEffect(() => {
    window.addEventListener('consent.onetrust', readDataAndSetConsentPref);

    if (window.OnetrustActiveGroups) {
      // window.OnetrustActiveGroups is a string of comma separated values like ',C0001,C0002,C0003,'
      const activeOneTrustGroups = window.OnetrustActiveGroups.split(
        ','
      ).filter((value: OneTrustConsentGroups) =>
        Object.values(OneTrustConsentGroups).includes(value)
      ) as OneTrustConsentGroups[];

      if (activeOneTrustGroups.length > 0) setConsentData(activeOneTrustGroups);
    }

    return () => {
      window.removeEventListener('consent.onetrust', readDataAndSetConsentPref);
    };
  }, []);

  useEffect(() => {
    const userAcceptedTracking = consentData.includes(
      OneTrustConsentGroups.PerformanceCookies
    );

    userAcceptedTracking
      ? postHog.opt_in_capturing()
      : postHog.opt_out_capturing();

    const recordingAlreadyStarted = postHog.sessionRecordingStarted();
    const sessionRecordingViaNPMPackageFeatureEnabled = postHog.isFeatureEnabled(
      'session-recording-via-npm-package'
    );

    if (sessionRecordingViaNPMPackageFeatureEnabled) {
      if (userAcceptedTracking && !recordingAlreadyStarted) {
        postHog.startSessionRecording();
      } else if (!userAcceptedTracking && recordingAlreadyStarted) {
        postHog.stopSessionRecording();
      }
    }
  }, [consentData]);
};

export default useConsent;
